<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense dark color="secondary">
          <v-toolbar-title>Map Service</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="success" dark v-on="on" v-if="isDefault(mapLayerData.LayerName)">
                <v-icon class="mr-1">add</v-icon>{{ $t('Button.addMapService') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile v-for="(item, index) in menuItems" :key="index" @click="addRequstRule(item)">
                <v-list-tile-title>{{ item }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs12>
              <v-expansion-panel v-model="panel" expand id="header">
                <v-expansion-panel-content v-for="(mapService) in mapServiceList" :key="mapService.Id">
                  <template v-slot:header>
                    Map Service: {{ mapService.ServiceType }}
                    <v-spacer></v-spacer>
                  </template>
                  <template v-slot:actions>
                    <v-btn color="error" v-if="isDefault(mapLayerData.LayerName)" @click.stop="removeMapService(mapService.Id)">{{ $t('Button.Remove') }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs12 pl-3 pr-3 v-for="(item, i) in mapService.ServiceConfig" :key="i">
                          <v-text-field :label="item.key" v-model="item.value" :readonly="!isDefault(mapLayerData.LayerName)"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn class="btn_save" color="success" @click="save()" v-if="isDefault(mapLayerData.LayerName)">
            <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import SnackBarUtil from '../mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'
  const app = createNamespacedHelpers('app')

  export default {
    model: {
      prop: 'mapLayerData',
      event: 'returnMapService',
    },
    components: {
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      mapLayerData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        IdCount: 0,
        panel: Array(this.mapLayerData.MapServices.length).fill(true),
        suffix: '_copy',
        CollectionsList: [],
        ProcessingAction: ['Do Nothing'],
        editable: true,
        serviceTypeDict: {
          //basemapLayer: [{key: 'text'}],
          imageMapLayer: [{ key: 'url' }, { key: 'opacity' }, { key: 'format' }, { key: 'noData' }],
          dynamicMapLayer: [{ key: 'url' }, { key: 'zIndex' }],
          //wms: [{key: 'url'},{key: 'format'},{key: 'layers'},{key: 'maxcc'},{key: 'priority'}],
          tiledMapLayer: [{ key: 'url' }],
          geojson: [{ key: 'url' }],
        },
        menuItems: [
          //'basemapLayer', 
          'imageMapLayer', 'dynamicMapLayer', 'wms', 'tiledMapLayer', 'geojson',
        ],
        mapServiceList: [],
      }
    },
    computed: {
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {},
    mounted() {
      this.setMapServiceList()
    },
    methods: {
      ...app.mapActions(['updateMapServices']),
      setMapServiceList() {
        var data = JSON.parse(JSON.stringify(this.mapLayerData))
        this.mapServiceList = data.MapServices.map(x => {
          var arr = []
          var obj = JSON.parse(x.ServiceConfig)
          for (var y in obj) {
            arr.push({
              key: y,
              value: obj[y],
            })
          }
          return {
            Id: x.Id,
            ServiceConfig: arr,
            ServiceType: x.ServiceType,
          }
        })
      },
      isDefault(data) {
        var arr = ['topo', 'station', 'sat']
        var match = arr.find(x => x == data)
        if (match == null) {
          return true
        }
        return false
      },
      addRequstRule(type) {
        this.IdCount--
        this.mapServiceList.push({
          Id: this.IdCount,
          ServiceConfig: this.serviceTypeDict[type],
          ServiceType: type,
        })
        this.panel.push(true)
      },

      removeMapService(Id) {
        var item = this.mapServiceList.find(x => x.Id == Id)
        var index = this.mapServiceList.indexOf(item)
        this.mapServiceList.splice(index, 1)
      },

      save() {
        var data = this.mapServiceList.map(x => {
          var arr = []
          x.ServiceConfig.forEach(element => {
            arr.push(`"${element.key}": "${element.value}"`)
          })
          var str = '{' + arr.join(',') + '}'
          return {
            Id: x.Id > 0 ? x.Id : null,
            ServiceConfig: str,
            ServiceType: x.ServiceType,
          }
        })
        let options = {
          data: {
            Id: this.mapLayerData.Id,
            MapServices: data,
          },
          successCb: () => {
            this.setMapServiceList()
            this.snackMessage = 'Save success.'
            this.snackColor = 'success'
            this.snackbar = true
          },
          failedCb: (err) => {
            this.$store.dispatch('app/setErrorDialog', {
              data: err.response.data,
              title: err.message,
              show: true,
            })
          },
        }
        this.updateMapServices(options)
      },
    },
  }
</script>

<style scoped lang="stylus">
  .btn_save {
    margin: 0 auto;
    display: block;
    width: 30%;
  }
</style>